// Core
import { takeEvery, all, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';


// Workers
import { 
    fetchShiftClose,
    fetchShiftCurrent,
    fetchShiftOpen,
    fetchShiftCreate,
    fetchShiftDetail,
    fetchShiftAutoFillWorker
 } from './worker';
import { shiftClose, shiftOpen, shiftCurrent, shiftCreate, shiftDetail, shiftAutoFill } from '../actions';

function* watchFetchCurrent(): SagaIterator {
    yield takeEvery(shiftCurrent.async, fetchShiftCurrent);
}
function* watchFetchOpen(): SagaIterator {
    yield takeEvery(shiftOpen.async, fetchShiftOpen);
}

function* watchFetchClose(): SagaIterator {
    yield takeEvery(shiftClose.async, fetchShiftClose);
}

function* watchFetchCreate(): SagaIterator {
    yield takeEvery(shiftCreate.async, fetchShiftCreate);
}

function* watchFetchDetail(): SagaIterator {
    yield takeEvery(shiftDetail.async, fetchShiftDetail);
}

function* watchFetchAutoFill(): SagaIterator {
    yield takeEvery(shiftAutoFill.async, fetchShiftAutoFillWorker);
}


export function* watchShift(): SagaIterator {
    yield all([
        call(watchFetchCurrent),
        call(watchFetchOpen),
        call(watchFetchClose),
        call(watchFetchCreate),
        call(watchFetchDetail),
        call(watchFetchAutoFill),
    ]);
}